module.exports = __webpack_public_path__ + "img/软件企业证书.87ab32e3.jpg";